import { z } from 'zod'

export const contactSchema = z.object({ 
  id: z.number(),
  name: z.string(),
  phone: z.string(),
  email: z.string().nullable(),
  profilePicUrl: z.string().nullable(),
  tags: z.array(z.object({
    id: z.number(),
    name: z.string(),
    color: z.string(),
  })),
})

export type Contact = z.infer<typeof contactSchema>
